import * as PIXI from 'pixi.js';

const BORDER = 0;
export class PlotComponent extends PIXI.Sprite {
    constructor({
       width, height, series
    } = {}) {
        super(PIXI.Texture.WHITE);

        this.anchor.set(0.5, 0.5);
        const graphics = new PIXI.Graphics();
        graphics.width = width;
        graphics.height = height;
        
        let x = -width / 2;
        const barWidth = width / series.length;
        for (let i = 0; i < series.length; i++) {
            graphics.beginFill(0xFF3333 - series[i] * 140);
            const y = 0;
            graphics.drawRect(x, y, barWidth, -height * series[i]);
            graphics.endFill();
            x += (barWidth + BORDER);
        }
        return graphics;
    }
}